import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { PegGraphRes } from "../patients/index.type";

const useFetchPhqGraphPage = (billingCycleId: string) => {
  const [phqGraph, setPhqGraph] = React.useState<PegGraphRes | null>(null);

  const { loading: phqGraphLoading, makeApiCall } = useApi({
    url: `/rtm/patient-dashboard/cron/pdf/v3/phq-chart/${billingCycleId}`,
    method: "GET",
    preAuth: true,
  });

  const getPhqGraphData = async () => {
    if (!billingCycleId) return;

    const { response } = await makeApiCall<undefined, PegGraphRes>();

    if (response?.status === "success") {
      setPhqGraph(response);
    } else {
      setPhqGraph(null);
    }
  };

  return {
    phqGraph,
    getPhqGraphData,
    phqGraphLoading,
  };
};

export default useFetchPhqGraphPage;
